
class SalesInvoiceDetailViewController extends InvoiceDetailViewController
{
    static newInstance(): SalesInvoiceDetailViewController {
        let vc = new SalesInvoiceDetailViewController("sales-invoice-detail-view");
        vc.initWithResource("layout/invoices/SalesInvoiceDetailView.html");
        return vc;
    }

    private uploadButton:MUIButton = null;

    viewDidLoad(){
        super.viewDidLoad();

        this.uploadButton = MUIOutlet(this, "upload-btn", "MUIButton");
        this.uploadButton.setAction(this, function(this:SalesInvoiceDetailViewController){
            this.openUploadPanel();
        });
    }

    private openUploadPanel(){
        let panel = MUIOpenPanel.openPanel();
        panel.allowedFileTypes = ["pdf", "png", "jpg", "jpeg"];
        panel.beginSheetModalForWindow(this.view.window, this, function(this:SalesInvoiceDetailViewController, result:number){
            if (result != MIOFileHandlingPanel.OKButton) return;
            let file = panel.files[0];
            if (file == null) return;
            let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
            ad.webService.uploadInvoiceFile(this.invoice, file, function(code:number, data:any){
                if (code == 200) {
                    AppHelper.showInfoMessage(null, MIOLocalizeString("SUCCESS", "SUCCESS"), MIOLocalizeString("FILE_UPLOADED_SUCCESSFULLY", "File uploaded successfully."));
                } else {
                    AppHelper.showErrorMessage(null, MIOLocalizeString("ERROR", "ERROR"), MIOLocalizeString("COULDNT_UPLOAD_FILE", "Couldn't upload file. Please try again."));
                }
            });
        });
    }
}